import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { API_HEADERS } from "../api-headers";
import { userContextStore } from "./user-context.store";

export interface ApiRequestOptions {
  context?: HttpContext;
  headers?: Record<string, string>;
  params?: Record<string, string>;
}

@Injectable({ providedIn: "root" })
export class ApiClient {
  private readonly http = inject(HttpClient);
  private readonly localeStore = inject(userContextStore);

  get<T>(path: string, options: ApiRequestOptions = {}): Observable<T> {
    return this.http.get<T>(`${environment.api.baseUrl}${path}`, {
      context: options.context,
      headers: {
        [API_HEADERS.countryCode]: this.localeStore.country(),
        [API_HEADERS.language]: this.localeStore.language(),
        ...options.headers,
      },
      params: options.params,
    });
  }

  post<T>(
    path: string,
    body: unknown,
    options: ApiRequestOptions = {},
  ): Observable<T> {
    return this.http.post<T>(`${environment.api.baseUrl}${path}`, body, {
      context: options.context,
      headers: {
        [API_HEADERS.countryCode]: this.localeStore.country(),
        [API_HEADERS.language]: this.localeStore.language(),
        ...options.headers,
      },
      params: options.params,
    });
  }

  put<T>(
    path: string,
    body: unknown,
    options: ApiRequestOptions = {},
  ): Observable<T> {
    return this.http.put<T>(`${environment.api.baseUrl}${path}`, body, {
      context: options.context,
      headers: {
        [API_HEADERS.countryCode]: this.localeStore.country(),
        [API_HEADERS.language]: this.localeStore.language(),
        ...options.headers,
      },
      params: options.params,
    });
  }

  delete<T>(path: string, options: ApiRequestOptions = {}): Observable<T> {
    return this.http.delete<T>(`${environment.api.baseUrl}${path}`, {
      context: options.context,
      headers: {
        [API_HEADERS.countryCode]: this.localeStore.country(),
        [API_HEADERS.language]: this.localeStore.language(),
        ...options.headers,
      },
      params: options.params,
    });
  }
}
